<template>
  <v-content>
    <v-container>
      <v-btn class="left info fill" @click="goBack">Back</v-btn>

      <div>
        <h3 class="text-center" justify-center>Login Attempts (Past 2 weeks)</h3>
        <v-layout text-xs-center wrap class="text-center" justify-center>
          <v-data-table
            :headers="headers"
            :items="dataPoints"
            :items-per-page="5"
            class="elevation-1"
          ></v-data-table>
        </v-layout>
      </div>

      <div class="mt-3">
        <h3 class="text-center" justify-center>Common Attempts (Past 2 weeks)</h3>
        <v-layout text-xs-center wrap class="text-center" justify-center>
          <v-data-table
            :headers="groupHeaders"
            :items="groupedDataPoints"
            :items-per-page="5"
            class="elevation-1"
          ></v-data-table>
        </v-layout>
      </div>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import moment from "moment";
import _ from "lodash";
export default {
  name: "AdminLoginStats",
  data: () => ({
    token: null,
    dataPoints: [],
    groupedDataPoints: [],
    headers: [
      {
        text: "Auditor ID",
        align: "left",
        sortable: false,
        value: "auditorID"
      },
      { text: "Timestamp", value: "createdAt" },
      { text: "Valid", value: "valid" }
    ],
    groupHeaders: [
      {
        text: "Auditor ID",
        align: "left",
        sortable: false,
        value: "auditorID"
      },
      { text: "Count", value: "count" },
      { text: "Valid", value: "valid" }
    ]
  }),
  mounted() {
    for (var i = 0, len = localStorage.length; i < len; ++i) {
      if (localStorage.key(i).indexOf("adal.access.token.key") !== -1) {
        this.token = localStorage.getItem(localStorage.key(i));
      }
    }
    this.getInfo();
  },
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    }
  },
  methods: {
    getInfo() {
      let config = {
        url: `${this.getBaseUrl}/admin/getLoginStats`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      };
      axios(config)
        .then(async response => {
          if (response.status === 200) {
            // Trim to last two weeks
            const TWO_WEEKS_OLD = moment()
              .subtract(14, "days")
              .startOf("day");
            response.data = _.filter(response.data, function(d) {
              return moment(d.createdAt).isAfter(TWO_WEEKS_OLD);
            });

            let data = [];
            let validCache = [];
            for (let i = 0; i < response.data.length; i++) {
              let finalData = {
                auditorID: response.data[i].auditorID,
                createdAt: null,
                valid: null
              };
              finalData.createdAt = moment(response.data[i].createdAt).format(
                "MMMM Do YYYY, h:mm:ss a"
              );

              // Validate auditorID
              let validateConfig = {
                url: `${this.getBaseUrl}/admin/getAuditEventbyAuditorID/${response.data[i].auditorID}`,
                method: "GET",
                headers: {
                  Authorization: `Bearer ${this.token}`
                }
              };
              try {
                _.forEach(validCache, cacheItem => {
                  if (cacheItem.auditorID === response.data[i].auditorID) {
                    finalData.valid = cacheItem.valid;
                  }
                });

                if (finalData.valid === null) {
                  let res = await axios(validateConfig);

                  if (res.status === 200) {
                    if (res.data) {
                      finalData.valid = true;
                    } else {
                      finalData.valid = false;
                    }
                    validCache.push({
                      auditorID: response.data[i].auditorID,
                      valid: finalData.valid
                    });
                  }
                }
              } catch (error) {
                finalData.valid = false;
              }

              data.push(finalData);
            }

            this.groupData(data);
            this.dataPoints = data;
          } else {
            this.dataPoints = [];
          }
        })
        .catch(err => {
          console.log(err);
          this.dataPoints = [];
        });
    },
    groupData(data) {
      let groupData = _.groupBy(data, "auditorID");
      let groupDataArr = [];
      _.forEach(groupData, dataPoint => {
        groupDataArr.push({
          auditorID: dataPoint[0].auditorID,
          count: dataPoint.length,
          valid: dataPoint[0].valid
        });
      });
      groupDataArr = _.orderBy(groupDataArr, ["count"], ["desc"]);
      this.groupedDataPoints = groupDataArr;
    },
    goBack() {
      this.$router.push(`/admin`);
    }
  }
};
</script>
